module.exports = __webpack_public_path__ + "img/5sixieme.b44dad6a.jpg";